import { clsx } from "clsx";
import { Stack } from "@/components/Stack/Stack";
import type { BlogCardView } from "@/utils/blog/types";

export interface BlogPostCardProps {
  post: BlogCardView;
  index: number;
}

/**
 * A single post card for the index grid and the related rail: 16:9 rounded
 * cover, tag chip + date + read time meta line, title, description and a
 * «Читать →» link. The whole card is an anchor so the tap target is the card.
 */
export function BlogPostCard({ post, index }: BlogPostCardProps) {
  return (
    <a
      href={post.href}
      className="blog-card"
      data-component="BlogPostCard"
      data-track={`blog-index.card.${index}`}
    >
      <div className={clsx("blog-card-cover", !post.cover && "blog-card-cover-empty")}>
        {post.cover ? <img src={post.cover} alt="" loading="lazy" /> : null}
      </div>
      <Stack gap={12} className="blog-card-body">
        <div className="blog-card-meta">
          {post.tagLabel ? <span className="pill-tag lav">{post.tagLabel}</span> : null}
          <span className="blog-card-dot">
            {post.dateLabel}
            {post.dateLabel && post.readLabel ? " · " : ""}
            {post.readLabel}
          </span>
        </div>
        <h3 className="blog-card-title">{post.title}</h3>
        {post.description ? <p className="blog-card-desc">{post.description}</p> : null}
        <span className="blog-read-link">Читать →</span>
      </Stack>
    </a>
  );
}

BlogPostCard.displayName = "BlogPostCard";
